import { render, staticRenderFns } from "./user-menu.vue?vue&type=template&id=39c94dae&scoped=true&"
import script from "./user-menu.vue?vue&type=script&lang=js&"
export * from "./user-menu.vue?vue&type=script&lang=js&"
import style0 from "./user-menu.vue?vue&type=style&index=0&id=39c94dae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39c94dae",
  null
  
)

export default component.exports